import { atom } from 'jotai';

// Atom to store the total number of participants in the meeting
// This includes all participants, not just those visible on the current page
export const totalParticipantCountAtom = atom(1); // Default to 1 (just the local user)
